import React, { useState, useContext } from "react";
import { FiTrash2 } from "react-icons/fi";
import Switch from "@material-ui/core/Switch";
import Tooltip from "@material-ui/core/Tooltip";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { makeStyles } from "@material-ui/core/styles";

import { api } from "../../../Services/Api";
import { AnswersContext } from "../index";
import CreateAnswer from "../../CreateAnswer";
import LoadingContainer from "../../Loading/LoadingContainer";
import { Container, Required, Title, Actions } from "./styles";

const useStyles = makeStyles({
  root: {
    padding: "5px 5px",
    paddingTop: 0,
    "&:first-child": {
      paddingTop: 0,
    },
  },
});

function ItemAnswer({ data, onChange, onRemove, onChangeMany }) {
  const { product } = useContext(AnswersContext);
  const isMobile = useMediaQuery("(max-width:769px)");
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openDialogQuestion, setOpenDialogQuestion] = useState(false);
  const [openRemoveDialog, setOpenRemoveDialog] = useState(false);
  const [tempQuestion, setTempAnswer] = useState(undefined);
  const classes = useStyles();

  const questionsToUpdate = [];

  async function handleIsVisibilityChange(event) {
    event.stopPropagation();
    const checked = event.currentTarget.checked;
    try {
      await api.put(`/menu/questions/${data._id}/visibility`, {
        is_active: checked,
      });
      onChange({ ...data, is_active: checked });
    } catch (err) {
      alert("Erro inesperado ao alterar Pergunta");
    }
  }

  async function handleDoneChange(question) {
    if (questionsToUpdate.length === 1) {
      await updateOnApi({ ...data, ...question });
      return onChange({ ...data, ...question });
    }

    setOpenDialogQuestion(true);
    setTempAnswer(question);
  }

  async function remove() {
    try {
      await api.delete(`/menu/questions/${data._id}`);
      onRemove(data);
    } catch (err) {};
  }

  async function handleRemove(e) {
    setOpenRemoveDialog(true);

    e.stopPropagation();
    
  }



  function handleClose() {
    setOpenModal(false);
  }

  async function singleUpdate() {
    try {
      await updateOnApi({ ...data, ...tempQuestion, isTwins: false });
      onChange({ ...data, ...tempQuestion });
      setOpenDialogQuestion(false);
      setOpenModal(false);
    } catch (err) {
      alert("Erro inesperado ao alterar Pergunta");
    }
  }

  async function updateOnApi(question) {
    setLoading(true);
    await api.put(`/menu/questions/${question._id}`, question).then((res) => {
      setLoading(false);
      console.log("");
    });
  }

  async function allUpdate() {
    try {
      await updateOnApi({ ...data, ...tempQuestion, isTwins: true });
      //TODO: Como atualizar a lista de perguntas?
      onChange({ ...data, ...tempQuestion });
      setOpenDialogQuestion(false);
      setOpenModal(false);
    } catch (err) {
      alert("Erro inesperado ao alterar Pergunta");
    }
  }

  return (
    <>
      <Container
        onClick={() => setOpenModal(true)}
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          {/* <GrDrag style={{ opacity: '0.5', marginRight: '10px' }} /> */}
          <Title disabled={!data.is_active}>
            {data.nameShow}
            <br />
            <Required disabled={!data.is_active} show={data.required}>
              obrigatório
            </Required>
          </Title>
        </div>
        <Actions>
          <Tooltip arrow title="Excluir pergunta">
            <Button onClick={handleRemove}>
              <FiTrash2 style={{ color: "red", fontSize: "20px" }} />
            </Button>
          </Tooltip>
          <Tooltip arrow title="Habilitar pergunta">
            <Switch
              name="multiple"
              color="primary"
              checked={data.is_active}
              onChange={handleIsVisibilityChange}
              onClick={(e) => e.stopPropagation()}
            />
          </Tooltip>
        </Actions>
      </Container>
      <Dialog
        fullScreen={true}
        onClose={handleClose}
        open={openModal}
        tabIndex={10000000001}
      >
        <DialogContent
          classes={{
            root: classes.root,
          }}
        >
          <CreateAnswer
            initialState={data}
            onDone={handleDoneChange}
            onClose={handleClose}
            title={`Alterando pergunta`}
          />
        </DialogContent>
      </Dialog>
      <Dialog
        open={openDialogQuestion}
        onClose={() => setOpenDialogQuestion(false)}
      >
        <DialogTitle>{"Alterar em todos"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            A pergunta que você alterou está presente em outros produtos dessa
            categoria. Você deseja alterar em todos eles também, ou apenas nesse
            produto?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={singleUpdate} color="primary">
            Apenas nesse
          </Button>
          <Button onClick={allUpdate} color="primary" autoFocus>
            Em todos
          </Button>
        </DialogActions>
        <LoadingContainer show={loading} />
      </Dialog>

      <Dialog
        open={openRemoveDialog}
        onClose={() => setOpenRemoveDialog(false)}
      >
        <DialogTitle>Atenção!</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Deseja excluir a pergunta <strong>{data.nameShow}</strong>?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={remove} color="secondary">
            Sim
          </Button>
          <Button
            onClick={() => setOpenRemoveDialog(false)}
            color="default"
            autoFocus
          >
            Não
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ItemAnswer;
